export default __webpack_public_path__ + "static/media/duplose.13067227.mp3";